<template functional>
    <svg
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        :width="props.size"
        :height="props.size"
        viewBox="0 0 16 16"
    >
        <g>
            <path
                d="M2.5,3 H13.5 A1.5,1.5 0 0 1 15,4.5 V11.5 A1.5,1.5 0 0 1 13.5,13 H2.5 A1.5,1.5 0 0 1 1,11.5 V4.5 A1.5,1.5 0 0 1 2.5,3 Z"
                fill="none"
                stroke="#74788d"
                stroke-width="1"
                stroke-linecap="round"
                stroke-linejoin="round"
                :style="{ fill: 'none !important' }"
            />
            <path
                d="M1.5,4 L8,9.5 L14.5,4"
                fill="none"
                stroke="#74788d"
                stroke-width="1"
                stroke-linecap="round"
                stroke-linejoin="round"
                :style="{ fill: 'none !important' }"
            />
        </g>
    </svg>
</template>

<script>
export default {
    name: "IconEnvelope",

    props: {
        size: { type: [String, Number], default: "16px" },
    },
};
</script>
